import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'localmed-core';

import LoadC from '../../../legacyCore/icons/LoadC';
import ProviderCard from '../../components/ProviderCard';

import style from './OfficeProviderList.scss';

const OfficeProviderList = ({ loading, providers, reasonForVisit }) => {
  if (loading) {
    return (
      <div className={style['office-provider-list__loading']}>
        <LoadC spin /> Loading…
      </div>
    );
  }

  if (providers == null || providers.length === 0) {
    return (
      <div className={style['office-provider-list-alert']}>
        <Alert tier="warning">
          Sorry no providers could be found for your selected reason for visit.
        </Alert>
      </div>
    );
  }
  return (
    <ol className={`list-reset ${style['office-provider-list']}`} data-qa="office-provider-list">
      {providers.map((provider, index) => (
        <li
          key={provider.id}
          className={style['office-provider-list__item']}
          style={{ animationDelay: `${index * 50}ms` }}
          data-qa="office-provider-list__item"
        >
          <ProviderCard reasonForVisit={reasonForVisit} provider={provider} isOnWidget toWidget />
        </li>
      ))}
    </ol>
  );
};

OfficeProviderList.propTypes = {
  loading: PropTypes.bool,
  providers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ),
  reasonForVisit: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

export default OfficeProviderList;
